"use strict";function DynamicAdapt(t){this.type=t}DynamicAdapt.prototype.init=function(){const t=this;this.objects=[],this.daClassname="_dynamic_adapt_",this.nodes=document.querySelectorAll("[data-da]");for(let t=0;t<this.nodes.length;t++){const e=this.nodes[t],n=e.dataset.da.trim().split(","),a={};a.element=e,a.parent=e.parentNode,a.destination=document.querySelector(n[0].trim()),a.breakpoint=n[1]?n[1].trim():"767",a.place=n[2]?n[2].trim():"last",a.index=this.indexInParent(a.parent,a.element),this.objects.push(a)}this.arraySort(this.objects),this.mediaQueries=Array.prototype.map.call(this.objects,function(t){return"("+this.type+"-width: "+t.breakpoint+"px),"+t.breakpoint},this),this.mediaQueries=Array.prototype.filter.call(this.mediaQueries,function(t,e,n){return Array.prototype.indexOf.call(n,t)===e});for(let e=0;e<this.mediaQueries.length;e++){const n=this.mediaQueries[e],a=String.prototype.split.call(n,","),i=window.matchMedia(a[0]),r=a[1],s=Array.prototype.filter.call(this.objects,function(t){return t.breakpoint===r});i.addListener(function(){t.mediaHandler(i,s)}),this.mediaHandler(i,s)}},DynamicAdapt.prototype.mediaHandler=function(t,e){if(t.matches)for(let t=0;t<e.length;t++){const n=e[t];n.index=this.indexInParent(n.parent,n.element),this.moveTo(n.place,n.element,n.destination)}else for(let t=0;t<e.length;t++){const n=e[t];n.element.classList.contains(this.daClassname)&&this.moveBack(n.parent,n.element,n.index)}},DynamicAdapt.prototype.moveTo=function(t,e,n){e.classList.add(this.daClassname),"last"===t||t>=n.children.length?n.insertAdjacentElement("beforeend",e):"first"!==t?n.children[t].insertAdjacentElement("beforebegin",e):n.insertAdjacentElement("afterbegin",e)},DynamicAdapt.prototype.moveBack=function(t,e,n){e.classList.remove(this.daClassname),void 0!==t.children[n]?t.children[n].insertAdjacentElement("beforebegin",e):t.insertAdjacentElement("beforeend",e)},DynamicAdapt.prototype.indexInParent=function(t,e){const n=Array.prototype.slice.call(t.children);return Array.prototype.indexOf.call(n,e)},DynamicAdapt.prototype.arraySort=function(t){"min"===this.type?Array.prototype.sort.call(t,function(t,e){return t.breakpoint===e.breakpoint?t.place===e.place?0:"first"===t.place||"last"===e.place?-1:"last"===t.place||"first"===e.place?1:t.place-e.place:t.breakpoint-e.breakpoint}):Array.prototype.sort.call(t,function(t,e){return t.breakpoint===e.breakpoint?t.place===e.place?0:"first"===t.place||"last"===e.place?1:"last"===t.place||"first"===e.place?-1:e.place-t.place:e.breakpoint-t.breakpoint})};const da=new DynamicAdapt("max");da.init();

function initCatalogSlider() {
   new Swiper(".catalog-slider", {
      spaceBetween: 12,
      slidesPerView: "auto",
      speed: 1e3
   })
}

function initFaq() {
   document.querySelectorAll(".faq-question").forEach(function (e) {
      e.addEventListener("click", function (e) {
         e.preventDefault();
         const i = this.closest(".faq-item"),
            t = i.querySelector(".faq-answer");
         jQuery(t).slideToggle(300), i.classList.toggle("is-active")
      })
   })
}

function initFeaturedSlider() {
   new Swiper(".featured-slider", {
      spaceBetween: 12,
      slidesPerView: "auto",
      speed: 1e3
   })
}

function initIngredientsSlider() {
   new Swiper(".ingredients-slider", {
      spaceBetween: 8,
      slidesPerView: "auto",
      speed: 1e3
   })
}

function initLovedSlider() {
   new Swiper(".loved-slider", {
      spaceBetween: 12,
      slidesPerView: "auto",
      speed: 1e3
   })
}

function productDescriptionToggle() {
   const e = document.getElementById("show-more"),
      i = document.getElementById("show-less"),
      t = document.getElementById("product-description-long");
   e && e.addEventListener("click", function (s) {
      s.preventDefault(), e.classList.remove("is-active"), e.classList.add("is-disabled"), i.classList.add("is-active"), i.classList.remove("is-disabled"), jQuery(t).slideDown(300)
   }), i && i.addEventListener("click", function (s) {
      s.preventDefault(), e.classList.add("is-active"), e.classList.remove("is-disabled"), i.classList.remove("is-active"), i.classList.add("is-disabled"), jQuery(t).slideUp(300)
   })
}

/* Desktop-only thumbnail column styles (768px and up). Mobile layout is untouched. */
function injectDesktopGalleryStyles() {
   if (document.getElementById("dt-desktop-gallery-styles")) return;
   const s = document.createElement("style");
   s.id = "dt-desktop-gallery-styles";
   s.textContent =
      ".product-subslider-btn{display:none}" +
      "@media (min-width:768px){" +
      ".product-one{padding-left:84px}" +
      ".product-subslider{width:64px;top:32px;bottom:32px}" +
      ".product-one.dt-thumbs-fit .product-subslider{top:0;bottom:0}" +
      ".product-subslider-btn{display:flex;align-items:center;justify-content:center;position:absolute;left:0;z-index:2;width:64px;height:24px;padding:0;border:0;border-radius:4px;background:rgba(255,255,255,.1);color:#fff;cursor:pointer;transition:opacity .3s ease,background-color .3s ease}" +
      ".product-subslider-btn:hover{background:rgba(255,255,255,.2)}" +
      ".product-subslider-prev{top:0}" +
      ".product-subslider-next{bottom:0}" +
      ".product-subslider-btn.swiper-button-disabled{opacity:.3;cursor:default}" +
      ".product-subslider-btn.swiper-button-lock{display:none}" +
      "}";
   document.head.appendChild(s);
}

/* Mobile-only (under 750px): related products become a swipeable row instead of a stacked list. */
function injectMobileRelatedStyles() {
   if (!document.querySelector(".related-products") || document.getElementById("dt-mobile-related-styles")) return;
   const s = document.createElement("style");
   s.id = "dt-mobile-related-styles";
   s.textContent =
      "@media (max-width:749px){" +
      ".related-products ul.product-grid{display:flex;flex-wrap:nowrap;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;column-gap:12px;margin-right:-1.5rem;padding-right:1.5rem}" +
      ".related-products ul.product-grid::-webkit-scrollbar{display:none}" +
      ".related-products ul.product-grid > .grid__item{flex:0 0 78%;width:78%;max-width:78%;scroll-snap-align:start}" +
      "}";
   document.head.appendChild(s);
}

function initProductSubsliders() {
   const one = document.querySelector(".product-one");
   let prev = null, next = null;
   if (one && document.querySelector(".product-subslider")) {
      injectDesktopGalleryStyles();
      const chevron = function (d) {
         return '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="' + d + '" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      };
      prev = document.createElement("button");
      prev.type = "button";
      prev.className = "product-subslider-btn product-subslider-prev";
      prev.setAttribute("aria-label", "Previous images");
      prev.innerHTML = chevron("M4 10l4-4 4 4");
      next = document.createElement("button");
      next.type = "button";
      next.className = "product-subslider-btn product-subslider-next";
      next.setAttribute("aria-label", "More images");
      next.innerHTML = chevron("M4 6l4 4 4-4");
      one.appendChild(prev);
      one.appendChild(next);
   }
   const opts = {
      spaceBetween: 4,
      slidesPerView: "auto",
      freeMode: !0,
      watchSlidesProgress: !0,
      mousewheel: {
         forceToAxis: !0,
         releaseOnEdges: !0
      },
      breakpoints: {
         768: {
            direction: "vertical",
            spaceBetween: 10
         }
      }
   };
   if (prev && next) {
      opts.navigation = {
         prevEl: prev,
         nextEl: next
      };
      const syncFit = function (sw) {
         one.classList.toggle("dt-thumbs-fit", !!sw.isLocked);
      };
      opts.on = {
         init: syncFit,
         lock: syncFit,
         unlock: syncFit,
         resize: syncFit
      };
   }
   const e = new Swiper(".product-subslider", opts);
   new Swiper(".product-slider", {
      spaceBetween: 10,
      thumbs: {
         swiper: e
      }
   })
}

function initProductAccordion() {
   document.querySelectorAll(".product-accordion-btn").forEach(function (e) {
      e.addEventListener("click", function (e) {
         e.preventDefault();
         const i = this.closest(".product-accordion-item"),
            t = i.querySelector(".product-accordion-content");
         jQuery(t).slideToggle(300), i.classList.toggle("is-active")
      })
   })
}
initCatalogSlider(), initFaq(), initFeaturedSlider(), initIngredientsSlider(), initLovedSlider(), productDescriptionToggle(), initProductSubsliders(), injectMobileRelatedStyles(), initProductAccordion(), Fancybox.bind("[data-fancybox]", {});
const storiesSlider = new Swiper(".stories-slider", {
   slidesPerView: "auto",
   spaceBetween: 8,
   breakpoints: {
      1024: {
         spaceBetween: 12,
         slidesPerView: 4
      }
   }
});
